<template>
  <div class="p-1">
    <error slot="description" :errors="errors"/>
    <success :success="success"/>
    <div class="md-layout md-layout-item w-100 p-0" style="overflow-y: scroll;overflow: no-display; height: 400px">

      <div
          class="p-0 md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
          v-for="(product, key) in products" :key="'product'+key"
      >
        <b-button class="md-card-backdrop text-white w-100" v-b-toggle="'collapse_product-'+key" variant="light" style="font-size:15px;background-color: rgb(24, 66, 119);width: 100%">
          {{ product.product }}
          <md-icon>expand_more</md-icon>
        </b-button>


        <b-collapse :id="'collapse_product-'+key" >
          <div v-for="(data_weight, item) in product.data_product" :key="'weight'+item">
            <b-button v-b-toggle="'collapse_base-'+key+'-'+item" variant="light"  style="font-size: 15px; background-color: rgb(24 66 119 / 69%);width: 100%">
              {{ data_weight.base.name }}, {{data_weight.weight}}кг
              <md-icon>expand_more</md-icon>
            </b-button>
            <b-collapse :id="'collapse_base-'+key+'-'+item" v-if="product.data_product[item].price">
              <md-field>
                <label>Цена покупки, грн</label>
                <md-input v-model="data_weight.price.purchase_price" type="number" @keypress="isLetter($event)"></md-input>
              </md-field>
              <md-field>
                <label>Цена продажи, грн</label>
                <md-input v-model="data_weight.price.selling_price" type="number" @keypress="isLetter($event)"></md-input>
              </md-field>
            </b-collapse>
          </div>
        </b-collapse>
      </div>
    </div>

    <md-button class="md-warning" @click="changePrice()">Изменить</md-button>
  </div>
</template>

<script>

import Error from "./Error";
import Success from "./Success";
import {mapActions} from "vuex";

export default {
  name: "UserProducts",
  components: {Success, Error},
  props: ['products'],
  data() {
    return {
      price_products: [],
      errors: null,
      success: null,
      contHeight: 300
    }
  },
  computed:{

  },
  methods: {
    ...mapActions(["account/changePriceProduct"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if(/[[0-9.]/.test(char)) return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    changePrice() {
      for (let i in this.products) {
        for (let j in this.products[i].data_product) {
          if (this.products[i].data_product[j].price.purchase_price || this.products[i].data_product[j].price.selling_price) {
            this.price_products.push({
              product_weight_id: this.products[i].data_product[j].product_weight_id,
              purchase_price: this.products[i].data_product[j].price.purchase_price,
              selling_price: this.products[i].data_product[j].price.selling_price
            });
          }
        }
      }
      this.$store.dispatch('account/changePriceProduct', this.price_products)
          .then(() => {
            this.success = [
              'Данные успешно изменены'
            ]
          })
          .catch(err => {
            this.errors = [];
            if(err.message === 'The given data was invalid.') {
              for (let i in err.errors) {
                for (let j in err.errors[i]) {
                  this.errors.push(err.errors[i][j]);
                }
              }
            } else this.errors = err
          })
    },
  }
}
</script>

<style scoped>

</style>